import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { AuthContext, funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";
import useAtribuirProcesso from "./hooks/useAtribuirProcesso";
import useCancelarOs from "./hooks/useCancelarOs";
import useColumns from "./hooks/useColumns";
import useFormBuscaAvancada from "./hooks/useFormBuscaAvancada";
import useProrrogacaoOs from "./hooks/useProrrogacaoOs";
import useTitleBar from "./hooks/useTitleBar";
import useTomarCiencia from "./hooks/useTomarCiencia";
import ExecutarOrdemServicoDetalhes from "./components/ExecutarOrdemServicoDetalhes";
import ExecutarOrdemServicoPaginatedView from "../../../components/UI/PaginatedView/ExecutarOrdemServicoPaginatedView";
import useResponsabilidadeOrgao from "./hooks/useResponsabilidadeOrgao";
import { paginatedViewActions } from "../../../redux/paginatedView";

const reduxKey = "executarOs";

const ExecutaOS = ({ history, match }) => {
  const { user } = useContext(AuthContext);
  const { formik, form } = useFormBuscaAvancada();
  const { tomarCienciaModal, setShowCienciaConfirm, setShowAlertaNaoCiencia } = useTomarCiencia(history);
  const { cancelarOsModal, verificaOs } = useCancelarOs({ formik });
  const { atribuirProcessoModal, setShowAtribuirProcessoConfirm } = useAtribuirProcesso({ formik });
  const { prorrogacaoOsModal, setShowProrrogarOsConfirm } = useProrrogacaoOs({ formik });
  const { titleBar, titleBarParams } = useTitleBar({ reduxKey });
  const { responsabilidadeOrgao } = useResponsabilidadeOrgao(user.codigo);

  const columns = useColumns({
    setShowAtribuirProcessoConfirm,
    setShowProrrogarOsConfirm,
    setShowAlertaNaoCiencia,
    setShowCienciaConfirm,
    verificaOs,
    responsabilidadeOrgao,
  });

  const dispatch = useDispatch();

  useState(() => {
    dispatch(
      paginatedViewActions.saveParams({
        reduxKey,
        params: {},
      }),
    );

    dispatch(
      paginatedViewActions.setShowAdvancedSearch({
        reduxKey,
        showAdvancedSearch: false,
      }),
    );

    dispatch(
      paginatedViewActions.setTitleBarParams({
        reduxKey,
        titleBarParams: {
          codUsuario: null,
          codAcao: 0,
          isTimer: 0,
          pageNumber: null,
          selectValue: null,
        },
      }),
    );
  }, []);

  return (
    <>
      {tomarCienciaModal}
      {cancelarOsModal}
      {atribuirProcessoModal}
      {prorrogacaoOsModal}
      <ExecutarOrdemServicoPaginatedView
        title="Executar OS"
        keyField="codigo"
        descriptionField="descricao"
        defaultSearch
        defaultSearchPlaceholder="Digite o Nº OS"
        queryService={apiRoutes.fiscalizacao.ordemservico.consultaOsExecutar}
        advancedSearchFormik={formik}
        titleBar={titleBar}
        titleBarParams={titleBarParams}
        columns={columns}
        onRowClicked={(row) => {
          if (
            row.diretorAtribuido !== user.codigo &&
            (responsabilidadeOrgao === "C" || responsabilidadeOrgao === "S")
          ) {
            toast.warning(
              "OS não pertence ao diretor logado, para atuar nela se faz necessário atribuí-la ao Diretor logado.",
            );
          } else if (
            row.diretorAtribuido !== user.codigo &&
            row.executores?.filter((executor) => executor.includes(user.nome)).length === 0
          ) {
            toast.warning("Usuário não é executor da OS!");
          } else if (responsabilidadeOrgao === "C" || responsabilidadeOrgao === "S") {
            history.push({
              pathname: `${match.url}/consulta`,
              state: { itemKey: row.codigo, responsabilidadeOrgao },
            });
          } else if (row.dataCiencia) {
            history.push({
              pathname: `${match.url}/consulta`,
              state: { itemKey: row.codigo, responsabilidadeOrgao },
            });
          } else {
            setShowAlertaNaoCiencia(true);
          }
        }}
        permissionInsert={funcionalidades.procedimentoFiscal.inserir}
        history={history}
        reduxKey={reduxKey}
        expandComponent={ExecutarOrdemServicoDetalhes}
      >
        {form}
      </ExecutarOrdemServicoPaginatedView>
    </>
  );
};

export default ExecutaOS;
